const ROUTER_PATH = 'info';

export default [
  {
    path: `/${ROUTER_PATH}`,
    name: `${ROUTER_PATH}`,
    component: () => import('./index.vue'),
    meta: {
      title: 'Документация',
    },
  },
];
